import React from 'react';
import classNames from 'classnames';
import Button, { ButtonProps } from './Button';

const WarningButton = ({ className, children, ...rest }: ButtonProps) => (
  <Button className={classNames(className, 'warning')} {...rest}>
    {children}
  </Button>
);

export default WarningButton;
